import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_SAMAN1_BALANCE = "getSaman1Balance";
export const GET_SAMAN2_BALANCE = "getSaman2Balance";
export const GET_SADERAT_BALANCE = "getSaderatBalance";

// mutation types
export const SET_SAMAN1_BALANCE = "setSaman1Balance";
export const SET_SAMAN2_BALANCE = "setSaman2Balance";
export const SET_SADERAT_BALANCE = "setSaderatBalance";


export default {
    state: {

        balanceSaman1: null,
        balanceSaman2: null,
        balanceSaderat: null,
    },
    getters: {

        loadedBalanceSaman1(state) {
            return state.balanceSaman1;
        },
        loadedBalanceSaman2(state) {
            return state.balanceSaman2;
        },
        loadedBalanceSaderat(state) {
            return state.balanceSaderat;
        },

    },
    actions: {
        /**
         * Get the saman1 balance
         * @param state
         * @param payload
         */
        [GET_SAMAN1_BALANCE](state, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(payload)
                    .then((response) => {
                        if (response.success)
                            state.commit(SET_SAMAN1_BALANCE, response.result.balance);
                        else
                            state.commit(SET_SAMAN1_BALANCE, 0); 
                    })
                    .catch((error) => {
                    })
                    .finally(() => { });
            });
        },
        /**
        * Get the saman2 balance
        * @param state
        * @param payload
        */
        [GET_SAMAN2_BALANCE](state, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(payload)
                    .then((response) => {
                        if (response.success)
                            state.commit(SET_SAMAN2_BALANCE, response.result.balance);
                        else
                        state.commit(SET_SAMAN2_BALANCE, 0);   
                    })
                    .catch((error) => {
                    })
                    .finally(() => { });
            });
        },
        /**
        * Set the balance saderat Status 
        * @param state
        * @param payload
        */
        [GET_SADERAT_BALANCE](state, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(payload)
                    .then((response) => {
                        if (response.success)
                            state.commit(SET_SADERAT_BALANCE, response.result.balance);
                        else
                        state.commit(SET_SADERAT_BALANCE, 0);
                    })
                    .catch((error) => {
                    })
                    .finally(() => { });
            });
        },

    },
    mutations: {

        [SET_SAMAN1_BALANCE](state, payload) {
            state.balanceSaman1 = payload;
        },
        [SET_SAMAN2_BALANCE](state, payload) {
            state.balanceSaman2 = payload;
        },
        [SET_SADERAT_BALANCE](state, payload) {
            state.balanceSaderat = payload;
        },

    }
};